import {FC} from 'react'
import {downloadTemplatePerson, uploadMasivePerson} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
const MasiveUploadPerson: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadMasivePerson(formData) // Use the service to upload the file
      return data
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplatePerson}
      handleSendService={handleUpload}
      title='Persona'
    />
  )
}

export {MasiveUploadPerson}
